import { ChevronDownIcon, CopyIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  IconButton,
  ListItem,
  OrderedList,
  SimpleGrid,
  Stack,
  Text,
  useClipboard,
  useMediaQuery,
  useToast,
  VStack,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import PaymentATM from "../components/card/payment/PaymentATM";
import PaymentKliring from "../components/card/payment/PaymentKliring";
import PaymentMobile from "../components/card/payment/PaymentMobile";

import BPD from "../assets/payment/bank-bpd.png";

function checkDay(num) {
  if (num === 0) {
    return "Minggu";
  } else if (num === 1) {
    return "Senin";
  } else if (num === 2) {
    return "Selasa";
  } else if (num === 3) {
    return "Rabu";
  } else if (num === 4) {
    return "Kamis";
  } else if (num === 5) {
    return "Jumat";
  } else if (num === 6) {
    return "Minggu";
  }
}

function addZero(num) {
  if (num < 10) {
    return "0" + num;
  }
  return num;
}

export default function BpdVa() {
  const data = window.history.state;
  const toast = useToast();
  const baseURL = process.env.REACT_APP_BASE_URL;
  const url = "/orders/verify/va";
  const [mobile] = useMediaQuery("(max-width: 600px)");

  const expiredDate = new Date();
  let hour = 23;
  let minute = 59;
  let second = 59;

  var IDRConvert = Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  });

  const { hasCopied: h1, onCopy: copyNoTagihan } = useClipboard(
    data.usr.payment_metadata.va_no
  );
  const { hasCopied: h2, onCopy: copyAtm } = useClipboard(
    data.usr.payment_metadata.va_prefix + data.usr.payment_metadata.va_no
  );
  const { hasCopied: h3, onCopy: copyTotal } = useClipboard(
    data.usr.grand_total
  );

  useEffect(() => {
    toast({
      title: "Text Disalin",
      description: "Berhasil menyalin text",
      duration: 1000,
      isClosable: true,
    });
  }, [h1, h2, h3]);

  const handleCopyClipboard = (val) => {
    console.log(val);

    navigator.clipboard
      .writeText(val)
      .then(() => {
        toast({
          title: "Text Disalin",
          description: "Berhasil menyalin text",
          duration: 1000,
          isClosable: true,
        });
      })
      .catch((e) => {
        console.log(e);
        toast({
          title: "Text Tidak Disalin",
          description: "Terjadi Kesalahan",
          duration: 1000,
          isClosable: true,
        });
      });
  };
  const handleCheckPayment = () => {
    axios
      .post(
        baseURL + url,
        {
          order_id: data.usr.order_id,
          no_va: data.usr.payment_metadata.va_no,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      )
      .then((res) => {
        const status = res.data.data.order_status;
        console.log(status);
        if (res.status === 200) {
          toast({
            title: "Status Pembayaran",
            description:
              status === "UNPAID"
                ? "Masih Belum Dibayarkan"
                : "Berhasil Dibayarkan",
            duration: 10000,
            status: status === "UNPAID" ? "warning" : "success",
            isClosable: true,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <Box display="flex" alignItems="center" flexDir="column" p="10">
      <Box border="1px solid #E0E0E0" borderRadius="10px">
        <Box display="flex" alignItems="center" p="3">
          <Text w="full" fontWeight="600" fontSize="20">
            Virtual Account
          </Text>
          <img src={BPD} alt="bpd-va" width="70px" />
        </Box>
        <Box border="1px solid #E0E0E0" />
        <Stack p="5" spacing={3}>
          <Box display="flex">
            <Box w="full">
              <Text>Nomor Tagihan Virtual Account BPD Bali</Text>
              <Text fontWeight="600" fontSize="20">
                {data.usr.payment_metadata.va_no}
              </Text>
            </Box>
            <Button variant="ghost" onClick={copyNoTagihan}>
              <Box display="flex" color="blue">
                Salin <CopyIcon />
              </Box>
            </Button>
          </Box>
          <Box display="flex">
            <Box w="full">
              <Text>ATM Bersama/Online/E-Banking Bank Lain</Text>
              <Text fontWeight="600" fontSize="20">
                {data.usr.payment_metadata.va_prefix +
                  data.usr.payment_metadata.va_no}
              </Text>
            </Box>
            <Button variant="ghost" onClick={copyAtm}>
              <Box display="flex" color="blue">
                Salin <CopyIcon />
              </Box>
            </Button>
          </Box>
          <Box>
            <Text>Total Pembayaran</Text>
            <Text fontWeight="600" fontSize="20">
              {IDRConvert.format(data.usr.grand_total)}
              <IconButton variant="ghost" color="blue" onClick={copyTotal}>
                <CopyIcon />
              </IconButton>
            </Text>
          </Box>
        </Stack>
      </Box>
      <SimpleGrid columns={[1, 2]} spacing={2} py="4">
        <Button variant="outline" onClick={handleCheckPayment}>
          Cek Status Pembayaran
        </Button>
        <Link to="/">
          <Button w="full" colorScheme="blue">
            Belanja Lagi
          </Button>
        </Link>
      </SimpleGrid>
      <Box w={mobile ? "sm" : "2xl"}>
        <Text fontWeight="600" fontSize="20" color="#131313">
          Cara pembayaran
        </Text>
        <Box p={mobile ? "0" : "4"}>
          <Text>PANDUAN PEMBAYARAN</Text>
          <Stack p="4" spacing={3}>
            <PaymentATM />
            <PaymentKliring />
            <PaymentMobile />
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}
